<div class="scan">
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="scan-right-side flex-fill vh-100 overflow-lg-auto">
      <div class="h-100 w-100 pb-4">
        <div
          class="header border-bottom drop-shadow pb-4 hw-65 w-100 justify-content-between d-flex align-items-center pt-4 px-4">
          <div class="fs-18 fw-700 text-justify ps-4"><img src="assets/images/icons/FM-logo-green.svg" alt="">
          </div>
        </div>
        @if (currentStep === 1) {
          <div class="upload-content py-3 px-3">
            <h2 class="fs-20 fw-800 mb-2" style="color: #282828;">Upload Service Documents</h2>
            <p class="fs-16 fw-600" style="color: #464747;">Make sure your document is Clear and legible.
            </p>
          </div>
          @if (manualUpload) {
            <div class="upload-content py-0 px-3">
              @for (doc of claimDocs; track doc) {
                <div class="upload-box d-flex align-items-center justify-content-between mb-2"
                  >
                  <div class="upload-title  flex-column  ">
                    <img [src]="!doc.uploaded ? 'assets/images/claims/file-minus-03.png' : 'assets/images/icons/pdf-icon.png'"
                      class="me-3" style="width: 24px; height: 24px;" />
                      <span class="fs-14 fw-700">
                        {{ doc.name }}
                        @if (doc.required) {
                          <span class="text-danger">*</span>
                        }
                      </span>
                    </div>
                    <div class="upload-document">
                      @if (!doc.uploaded) {
                        <span class="fs-14 fw-semibold cursor" style="color: #0046AF;"
                          (click)="openUploadFromModal(doc)">
                          Upload
                        </span>
                      }
                      @if (doc.uploaded) {
                        <div class="d-flex align-items-center gap-2">
                          <a [href]="doc.result_doc" target="_blank" class="decoration-none cursor">
                            <img src="assets\images\icons\file-show-eye.png" alt="">
                          </a>
                          <img src="assets\images\icons\red-close-circle.png" alt=""
                            (click)="removeDocument(doc)">
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (showAddmore) {
                    <div  class="add-more fs-14 fw-700 px-1 py-4">
                      <a href="" (click)="addDocument($event)">+ Add more Documents</a>
                    </div>
                  }
                  <button [class]=" !canSubmit() ? 'submit-btn border fs-16 fw-bold rounded' :'fw-bold fs-16'"
                    [disabled]="!canSubmit()" (click)="submitDocument()"
                    style="padding: 12px 24px; color: #181818; background-color: #FFC737; border: none; border-radius: 6px; width: 100%;">
                    Submit Document
                  </button>
                </div>
              }
            }

            @if (currentStep === 2) {
              <div class="success-message-container text-center py-5 px-3"
                style="min-height: 300px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <img src="assets/images/credit-images/confirm-tick.png" alt="Upload successfully"
                  style="width: 146px; height: 126px; margin-top: 135px; margin-bottom: 20px;">
                  <h2 class="fs-24 fw-800 mb-3" style="color: #282828;">Documents Submission <br>Completed
                  Successfully.</h2>
                  <p class="fs-16 fw-600" style="color: #464747;">Go back to your dashboard to finish
                    <br>submitting
                      your claim.
                    </p>
                    <!-- <button (click)="goToDashboard()"
                    style="margin-top: 30px; padding: 12px 24px; color: #FFFFFF; background-color: #0046AF; border: none; border-radius: 6px; font-weight: bold; font-size: 16px; cursor: pointer;">
                    Back To Claim
                  </button>   -->
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      @if (showUploadFromModal) {
        <div class="upload-from-modal" (click)="closeUploadFromModal()">
          <div class="upload-from-container text-center py-4" (click)="$event.stopPropagation()">
            <div class="upload-divider mx-auto mb-3"></div>
            <h4 class="fw-bold mb-4" style="color: #181818;">Upload From</h4>
            <!-- Camera Button -->
            <button class="btn btn-camera w-100 mb-3 py-3"
              style="background: #FCE7C2; color: #8B5C2A; border-radius: 16px; font-size: 1.5rem; font-weight: 600; border: none;"
              (click)="triggerCameraInput()">
              Camera
            </button>
            <input #cameraInput type="file" accept="image/*" capture="environment" style="display: none"
              (change)="handleFileInput($event)" />
              <!-- Gallery Button -->
              <button class="btn btn-gallery w-100 py-3"
                style="background: #D7E7FF; color: #2563EB; border-radius: 16px; font-size: 1.5rem; font-weight: 600; border: none;"
                (click)="triggerGalleryInput()">
                Upload From Gallery
              </button>
              <input #galleryInput type="file" accept="image/*" style="display: none" (change)="handleFileInput($event)" />
            </div>
          </div>
        }